import { useMemo } from "react";
import type { Option } from "@/constants/common";
import { useDebounce } from "@/hooks/use-debounce";
import { useLocationOptionsV2 } from "@/queries/use-location-options-v2";
import { getXtenantId } from "@/utils/utils";

export type UseGroupSessionOptions = {
  locationOptions: Option[];
  onSearchLocation: (value: string) => void;
};

/** Searchable Location options for a group session. */
export const useGroupSessionOptions = (): UseGroupSessionOptions => {
  const [locationSearch, onSearchLocation] = useDebounce<string>("");

  const { data: locations } = useLocationOptionsV2({
    searchString: locationSearch,
    xTENANTID: getXtenantId(),
  });

  const locationOptions = useMemo<Option[]>(
    () =>
      (locations?.data ?? [])
        .filter((row) => !!row.uuid)
        .map((row) => ({ value: row.uuid, label: row.name })),
    [locations]
  );

  return { locationOptions, onSearchLocation };
};
